import type { MessageInitShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { listBiddingSpotExecutionResults } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'
import type {
  ListBiddingSpotExecutionResultsRequestSchema,
  ListBiddingSpotExecutionResultsResponse,
} from '@ebalance/proto/bffuser/v1/bidding_spot_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * 約定結果 CSV (AC-BSP-115) の行と未着件数を、 ダウンロード操作のたびに 1 回取得する。
 * 読み取りだが、 押した時点の結果を 1 度だけ取りたい (cache を表示に使わない) ので mutation で呼ぶ。
 */
export function useListSpotExecutionResults(): UseMutationResult<
  ListBiddingSpotExecutionResultsResponse,
  ConnectError,
  MessageInitShape<typeof ListBiddingSpotExecutionResultsRequestSchema>
> {
  return useMutation(listBiddingSpotExecutionResults)
}
